import React, { useState } from "react";
import { formatDateTime } from "../../../utils/date";
import { Button, Modal, ModalHeader, ModalBody, Spinner, Badge, Table } from "reactstrap";
import { usePendingChanges } from "./hooks/usePendingChanges";
import { usePublishSync } from "./hooks/usePublishSync";
import styles from "./PublishCenter.module.scss";

const PublishCenter = ({ isOpen, toggle, masterStatus }) => {
  const [activeType, setActiveType] = useState("material");
  const { data: items = [], isLoading } = usePendingChanges(activeType);
  const publishMutation = usePublishSync();

  const handlePublish = () => {
    if (window.confirm(`Are you sure you want to publish all ${activeType} updates? This will notify all companies.`)) {
      publishMutation.mutate(activeType);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" style={{ maxWidth: "800px" }}>
      <ModalHeader toggle={toggle}>
        <i className="fa fa-paper-plane text-primary" /> Review &amp; Publish Master Updates
      </ModalHeader>
      <ModalBody>
        <div className={styles.typeTabs}>
          {["material", "labor", "carting"].map((type) => (
            <Button
              key={type}
              color={activeType === type ? "primary" : "light"}
              onClick={() => setActiveType(type)}
              size="sm"
              className={styles.typeBtn}
            >
              {type}{" "}
              {masterStatus[type] > 0 && (
                <Badge color="danger" className="ml-1" pill>
                  {masterStatus[type]}
                </Badge>
              )}
            </Button>
          ))}
        </div>

        <div className={styles.previewBox}>
          <h6 className={styles.previewTitle}>
            Recent Changes to {activeType.charAt(0).toUpperCase() + activeType.slice(1)}
            {masterStatus[activeType] > 50 && (
              <small className="text-muted ml-2">(Showing latest 50)</small>
            )}
          </h6>

          {isLoading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          ) : items.length === 0 ? (
            <div className={styles.emptyState}>
              No unpublished changes found for this category.
            </div>
          ) : (
            <Table size="sm" hover responsive borderless className={styles.table}>
              <thead className={styles.tableHead}>
                <tr>
                  <th style={{ width: "80px" }}>Action</th>
                  <th>Item / Label</th>
                  <th style={{ width: "150px" }}>Created At</th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item._id}>
                    <td>
                      <Badge color="success" style={{ width: "55px" }}>
                        {item.status}
                      </Badge>
                    </td>
                    <td className="font-weight-bold">{item.label}</td>
                    <td className="text-muted small">{formatDateTime(item.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </div>

        <div className={styles.footer}>
          <span className={styles.footerHint}>
            <i className="fa fa-info-circle mr-1" />
            Publishing will notify active companies to sync these items.
          </span>
          <Button
            color="primary"
            disabled={items.length === 0 || publishMutation.isPending}
            onClick={handlePublish}
            className={styles.publishBtn}
          >
            {publishMutation.isPending ? <Spinner size="sm" /> : `Publish ${activeType.toUpperCase()}`}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default PublishCenter;
